// Copia los parámetros de seguimiento (utm_*, src, sck, xcod, fbclid…) de la URL actual
// al enlace de pago, sin sobrescribir los que ya existan (p. ej. los añadidos por UTMify).
export function withTrackingParams(href: string): string {
  if (typeof window === "undefined") return href;
  try {
    const target = new URL(href, window.location.href);
    const current = new URLSearchParams(window.location.search);
    current.forEach((value, key) => {
      if (!target.searchParams.has(key)) target.searchParams.set(key, value);
    });
    return target.toString();
  } catch {
    return href;
  }
}
